import { FormattedMessage, useIntl } from 'react-intl'
import { Box } from '@mui/material'
import { Button, Dialog, DialogContent, DialogFooter, DialogHeader, Typography } from '@carto/meridian-ds/components'
import { ResourceType } from 'features/common'

export type TakeOverCanceledDialogProps = {
  userEmail: string
  open: boolean
  onClose: () => void
  resourceType: ResourceType
}

function TakeOverCanceledDialog({ userEmail, open, onClose, resourceType }: TakeOverCanceledDialogProps) {
  const intl = useIntl()
  return (
    <Dialog data-testid="takeover-canceled-dialog" open={open} onClose={onClose}>
      <DialogHeader onClose={onClose} title={<FormattedMessage id="collaboration.takeOverCanceledDialog.title" />} />
      <DialogContent>
        <Typography component={'span'} variant="body2" color="textSecondary">
          <FormattedMessage
            id="collaboration.takeOverCanceledDialog.message1"
            values={{
              user: userEmail,
              strong: (content) => <strong>{content}</strong>,
              resourceType
            }}
          />
          <Box mt={2}>
            <Typography component={'span'} variant="body2" color="textSecondary">
              <FormattedMessage
                id="collaboration.takeOverCanceledDialog.message2"
                values={{
                  resourceType: intl.formatMessage({ id: `common.shareDialog.resourceTypes.${resourceType}` })
                }}
              />
            </Typography>
          </Box>
        </Typography>
      </DialogContent>
      <DialogFooter>
        <Button onClick={onClose} color="primary">
          <FormattedMessage id="collaboration.takeOverCanceledDialog.understood" />
        </Button>
      </DialogFooter>
    </Dialog>
  )
}

export default TakeOverCanceledDialog
